import InsideSalesTable from '@dashboardWirelineInsideSalesDepartment/InsideSalesBookingList/InsideSalesTable/InsideSalesTable';

export default InsideSalesTable;
